module.exports = __webpack_public_path__ + "assets/img/dcone .5e75c16b.png";